import * as React from "react";
import type { SVGProps } from "react";

const FacilityAirport = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8333 5.50033L14.0833 8.25033L15.5833 15.667C15.6667 15.917 15.5833 16.2503 15.3333 16.417L14.75 17.0003C14.3333 17.417 13.5833 17.2503 13.4167 16.7503L11.25 11.167L8.41667 14.0003L8.58333 15.8337C8.58333 16.0837 8.5 16.3337 8.33333 16.5003L7.41667 17.417L5.66667 14.5003L2.75 12.7503L3.58333 11.667C3.75 11.5003 4 11.417 4.25 11.417L6.08333 11.5837L8.91667 8.75033L3.25 6.58366C2.75 6.33366 2.58333 5.66699 3 5.25033L3.58333 4.66699C3.75 4.50033 4.08333 4.41699 4.33333 4.41699L11.75 5.91699L14.5 3.16699C15.1667 2.50033 16.1667 2.50033 16.8333 3.16699V3.16699C17.5 3.83366 17.5 4.83366 16.8333 5.50033V5.50033Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityAirport.displayName = "FacilityAirport";

export default FacilityAirport;
